module.exports = __webpack_public_path__ + "media/images/young_pin_design_award_icon@2x-7e5cfc9451d05531dfa475638c05f269.png";